import React from 'react'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import Students from '../container/Students/Students'

const Contacts = () => {
  return (
    <div>
        <Navbar/>
        <Students/>
        <Footer/>
    </div>
  )
}

export default Contacts